<ng-container *transloco="let t">
    <div
        class="chart-container relative"
        [ngClass]="{
            'pt-0': from === 'Tracker',
        }"
    >
        <div class="zoom-indicator" *ngIf="interactiveMode">
            🔍 {{ t("Interactive · scroll to zoom") }}
        </div>
        <div
            class="chart-controls-stack"
            [class.chart-controls-stack--tracker]="from === 'Tracker'"
            [class.chart-controls-stack--dashboard]="from === 'dashboard'"
        >
        <div
            class="chart-header"
            [class.chart-header--dashboard]="from === 'dashboard'"
            [ngClass]="selectedSeriesList[0] !== 'default' ? 'mb-0' : 'mb-0'"
        >
            <ng-container *ngIf="from === 'dashboard'; else nonDashboardHeader">
                <div class="chart-dashboard-series-nav">
                    <button
                        mat-icon-button
                        (click)="
                            lang === 'ar'
                                ? goToNextSeries()
                                : goToPreviousSeries()
                        "
                        [disabled]="
                            seriesNames.length <= 1 ||
                            (lang === 'ar'
                                ? currentSeriesIndex === seriesNames.length - 1
                                : currentSeriesIndex === 0)
                        "
                    >
                        <mat-icon>{{
                            lang === "ar" ? "chevron_right" : "chevron_left"
                        }}</mat-icon>
                    </button>

                    <span
                        class="chart-dashboard-series-nav__label font-semibold text-center text-gradient"
                    >
                        {{ seriesNames[currentSeriesIndex] }}
                    </span>

                    <button
                        mat-icon-button
                        (click)="
                            lang === 'ar'
                                ? goToPreviousSeries()
                                : goToNextSeries()
                        "
                        [disabled]="
                            seriesNames.length <= 1 ||
                            (lang === 'ar'
                                ? currentSeriesIndex === 0
                                : currentSeriesIndex === seriesNames.length - 1)
                        "
                    >
                        <mat-icon>{{
                            lang === "ar" ? "chevron_left" : "chevron_right"
                        }}</mat-icon>
                    </button>
                </div>
            </ng-container>

            <ng-template #nonDashboardHeader>
                <ng-container
                    *ngIf="seriesNames.length <= 1; else multiSeriesDropdown"
                >
                    <ng-container
                        *ngIf="
                            selectedSeriesList.length &&
                            selectedSeriesList[0] !== 'default'
                        "
                    >
                        <!-- <mat-button-toggle-group [(ngModel)]="selectedSeriesList"
                            (change)="onMultiSeriesChange($event.value)" class="toggle-group">
                            <mat-button-toggle *ngFor="
                                    let seriesName of seriesNames;
                                    trackBy: trackBySeriesName
                                " [value]="seriesName" [ngClass]="{
                                    'bg-secondary text-white':
                                        selectedSeriesList.includes(seriesName)
                                }">
                                {{ seriesName }}
                            </mat-button-toggle>
                        </mat-button-toggle-group> -->
                    </ng-container>
                </ng-container>

                <ng-template #multiSeriesDropdown>
                    <mat-select-search class="w-full" [width]="'w-full'" [options]="seriesOptionsForSelect"
                        [placeholder]="t('Select series')" [label]="seriesGroupByLabel" [multiple]="true" [selectAll]="true"
                        [displayField]="'name'" [valueField]="'name'" [formControl]="seriesSelectControl"
                        (selectionChange)="onMultiSeriesChange($event)">
                    </mat-select-search>
                </ng-template>
            </ng-template>
        </div>

        <div class="chart-tools-container bg-white dark:bg-transparent mr-auto"
            [ngClass]="lang === 'ar' ? 'chart-tools-rtl' : 'chart-tools-ltr'">
            <!-- Shared color picker input and hidden trigger (outside template) -->
            <input #colorPickerInput [cpOKButton]="true" [cpCancelButton]="false" [cpOutputFormat]="'hex'"
                [cpSaveClickOutside]="false" [cpDialogDisplay]="'popup'" [cpPresetLabel]="'Preset Colors'"
                [colorPicker]="chartData.color || '#3498db'" (colorPickerSelect)="onColorChange($event)"
                (cpInputChange)="tempColor = sanitizeColor($event)" (cpCancelButtonClick)="tempColor = chartData?.color"
                (cpOKButtonClick)="onColorChange(tempColor)" cpPosition="bottom"
                style="position:absolute; visibility:hidden; width:0; height:0; border:0; padding:0; margin:0;" />

            <button mat-icon-button class="chart-tool-btn hidden" #colorPickerButton [cpOKButton]="true"
                [cpCancelButton]="false" [cpOutputFormat]="'hex'" [cpSaveClickOutside]="false"
                [cpDialogDisplay]="'popup'" [cpPresetLabel]="'Preset Colors'"
                [colorPicker]="chartData.color || '#3498db'" (colorPickerSelect)="onColorChange($event)"
                (cpInputChange)="tempColor = sanitizeColor($event)" (cpCancelButtonClick)="tempColor = chartData?.color"
                (cpOKButtonClick)="onColorChange(tempColor)" cpPosition="bottom">
                <mat-icon>color_lens</mat-icon>
            </button>

            <!-- Full toolbar. On tracker cards (fixed-width toolbar) icons that do
                 not fit on one row collapse into the 3-dot menu below (see
                 ChartToolbarOverflowDirective). Other contexts size to content, so
                 the feature is disabled there and the trigger is not rendered. -->
            <div
                class="chart-tools-inline"
                [chartToolbarOverflow]="from === 'Tracker'"
            >
                <ng-container
                    *ngTemplateOutlet="chartToolsContent"
                ></ng-container>
                <button
                    *ngIf="from === 'Tracker'"
                    mat-icon-button
                    class="chart-tool-btn chart-tools-overflow-trigger"
                    style="display: none !important"
                    [matMenuTriggerFor]="chartToolsMenu"
                    [matTooltip]="t('More tools')"
                >
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>

            <!-- Mobile/Tablet/Low-res: 3-dot button that opens menu -->
            <!-- <button mat-icon-button class="chart-tool-btn chart-tools-overflow-trigger" [matMenuTriggerFor]="chartToolsMenu"
                [matTooltip]="t('More options')">
                <mat-icon>more_vert</mat-icon>
            </button> -->

            <mat-menu
                #chartToolsMenu="matMenu"
                class="sai-menu chart-tools-overflow-menu"
                xPosition="before"
                panelClass="chart-tools-menu-panel"
            >
                <div class="chart-tools-menu-content">
                    <ng-container
                        *ngTemplateOutlet="chartToolsContent"
                    ></ng-container>
                </div>
            </mat-menu>

            <mat-menu #downloadMenu="matMenu" class="sai-menu">
                <button mat-menu-item (click)="downloadSvgAsPng(chartWrapper)">
                    <mat-icon>image</mat-icon>
                    <span>{{ t("Download as PNG") }}</span>
                </button>
                <button mat-menu-item (click)="exportToCSV()">
                    <mat-icon>table_view</mat-icon>
                    <span>{{ t("Download as CSV") }}</span>
                </button>
            </mat-menu>
        </div>
        </div>

        <ng-template #chartToolsContent>
            <ng-container
                *ngIf="
                    (from === 'Analytics' || from === 'Tracker') &&
                    !isFull &&
                    showTrackerDeleteToolbar
                "
            >
                <button
                    mat-icon-button
                    class="chart-tool-btn"
                    (click)="deleteChart(chartData)"
                    [matTooltip]="
                        from === 'Tracker'
                            ? t('Delete Tracker')
                            : t('Delete Chart')
                    "
                >
                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
            </ng-container>

            <ng-container *ngIf="chartOptions.chart?.['type'] !== 'pie' && chartOptions.chart?.['type'] !== 'donut'">
                <button mat-icon-button class="chart-tool-btn" (click)="toggleChartType()"
                    [matTooltip]="t('Toggle Line / Bar')" *ngIf="areLabelsNumericOrDate">
                    <mat-icon>{{
                        currentChartType !== "bar" ? "bar_chart" : "show_chart"
                    }}</mat-icon>
                </button>

                <button
                    mat-icon-button
                    class="chart-tool-btn"
                    (click)="toggleDataLabelsVisibility()"
                    [matTooltip]="t('Show Values')"
                >
                    <mat-icon>visibility</mat-icon>
                </button>

                <!-- Zoom controls: replace the native ApexCharts toolbar (hidden
                     via SCSS) with matching custom buttons so there is one
                     consistent pill. Line/area charts only - bar charts render
                     without the native zoom toolbar. -->
                <ng-container *ngIf="currentChartType === 'line'">
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="zoomInChart()"
                        [matTooltip]="t('Zoom In')"
                    >
                        <mat-icon>zoom_in</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="zoomOutChart()"
                        [matTooltip]="t('Zoom Out')"
                    >
                        <mat-icon>zoom_out</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="resetZoomChart()"
                        [matTooltip]="t('Reset Zoom')"
                    >
                        <mat-icon>restart_alt</mat-icon>
                    </button>
                </ng-container>

                <ng-container *ngIf="chartOptions.chart?.['type'] === 'bar'">
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="sortSeries('asc')"
                        [matTooltip]="t('Sort Ascending')"
                    >
                        <mat-icon>north</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="sortSeries('desc')"
                        [matTooltip]="t('Sort Descending')"
                    >
                        <mat-icon>south</mat-icon>
                    </button>
                </ng-container>
            </ng-container>

            <button
                mat-icon-button
                class="chart-tool-btn"
                [matMenuTriggerFor]="downloadMenu"
                [matTooltip]="t('Download')"
            >
                <mat-icon>download</mat-icon>
            </button>

            <ng-container *ngIf="
                    (from === 'chat' ||
                        from === 'activity' ||
                        from === 'incorrect-messages') &&
                    !isFull
                ">
                <button mat-icon-button class="chart-tool-btn" (click)="toggleBrowserFullscreen()" [matTooltip]="
                        isChartFullscreen
                            ? t('Exit Full Screen')
                            : t('Full Screen')
                    ">
                    <mat-icon>{{
                        isChartFullscreen ? "fullscreen_exit" : "fullscreen"
                        }}</mat-icon>
                </button>
            </ng-container>

            <ng-container
                *ngIf="
                    from === 'Analytics' ||
                    from === 'Tracker' ||
                    from === 'report'
                "
            >
                <button
                    mat-icon-button
                    class="chart-tool-btn"
                    [matTooltip]="t('Change Color')"
                    [matTooltipDisabled]="matTooltipDisabled"
                    (click)="openColorPicker(colorPickerButton)"
                >
                    <mat-icon>color_lens</mat-icon>
                </button>

                <ng-container *ngIf="from !== 'report' && !isFull">
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="expandChart(chartData)"
                        [matTooltip]="from === 'Tracker' ? t('Expand Tracker') : t('Expand Chart')"
                    >
                        <mat-icon>open_in_full</mat-icon>
                    </button>

                    <button *ngIf="from === 'Tracker'" mat-icon-button class="chart-tool-btn"
                        (click)="toggleBrowserFullscreen()" [matTooltip]="
                            isChartFullscreen
                                ? t('Exit Full Screen')
                                : t('Full Screen')
                        ">
                        <mat-icon>{{
                            isChartFullscreen
                            ? "close_fullscreen"
                            : "fullscreen"
                            }}</mat-icon>
                    </button>

                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="openDataTable(chartData)"
                        [matTooltip]="t('View Data Table')"
                    >
                        <mat-icon>table_chart</mat-icon>
                    </button>
                    <ng-container *ngIf="from !== 'Analytics'">
                        <button
                            mat-icon-button
                            class="chart-tool-btn"
                            (click)="openSettings(chartData)"
                            [matTooltip]="
                                from === 'Tracker'
                                    ? t('Edit Tracker')
                                    : t('Edit Chart')
                            "
                        >
                            <mat-icon>edit</mat-icon>
                        </button>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="from === 'Tracker' && !isFull">
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="addToPageFunc(chartData)"
                        [matTooltip]="t('Canvas')"
                    >
                        <mat-icon>library_add</mat-icon>
                    </button>

                    <button
                        *ngIf="showShareTracker"
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="shareTracker($event)"
                        [matTooltip]="t('Share tracker')"
                    >
                        <mat-icon [class.text-primary]="isTrackerShared"
                            >share</mat-icon
                        >
                    </button>

                    <button mat-icon-button class="chart-tool-btn" *ngIf="from !== 'report'" (click)="filter(chartData)"
                        [matTooltip]="t('Filter Tracker')">
                        <mat-icon [ngClass]="
                                chartData.appliedFilters?.length > 0
                                    ? 'text-gradient'
                                    : ''
                            "
                            >filter_alt</mat-icon
                        >
                    </button>
                </ng-container>

                <!-- Report: per-chart filter + date controls (only for tracker reports) -->
                <ng-container
                    *ngIf="
                        from !== 'report' &&
                        chartData?.trackerId &&
                        secondLevelFrom === 'tracker'
                    "
                >
                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="filter(chartData)"
                        [matTooltip]="t('Filter Tracker')"
                    >
                        <mat-icon
                            [ngClass]="
                                chartData.appliedFilters?.length > 0
                                    ? 'text-gradient'
                                    : ''
                            "
                            >filter_alt</mat-icon
                        >
                    </button>

                    <button
                        mat-icon-button
                        class="chart-tool-btn"
                        (click)="toggleReportDatePicker()"
                        [matTooltip]="t('Edit date filter')"
                    >
                        <mat-icon
                            [ngClass]="
                                reportStartDate || reportEndDate
                                    ? 'text-gradient'
                                    : ''
                            "
                            >today</mat-icon
                        >
                    </button>
                </ng-container>
            </ng-container>
        </ng-template>

        <div
            class="chart-container relative"
            [ngClass]="{
                'pt-0': from === 'Tracker',
            }"
        >
            <!-- Inline date pickers for report context (only for tracker reports) -->
            <div
                *ngIf="
                    from === 'report' &&
                    chartData?.trackerId &&
                    showReportDatePicker &&
                    secondLevelFrom === 'tracker'
                "
                class="w-full flex gap-2 items-center mb-2"
            >
                <mat-form-field appearance="fill" class="w-42 md:w-48 fuse-mat-dense">
                    <input
                        matInput
                        [matDatepicker]="rPicker1"
                        [(ngModel)]="reportStartDate"
                        [placeholder]="t('Start')"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="rPicker1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #rPicker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="fill" class="w-42 md:w-48 fuse-mat-dense">
                    <input
                        matInput
                        [matDatepicker]="rPicker2"
                        [(ngModel)]="reportEndDate"
                        [placeholder]="t('End')"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="rPicker2"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #rPicker2></mat-datepicker>
                </mat-form-field>
                <button mat-icon-button (click)="applyReportDateRange()">
                    <mat-icon class="text-xl text-gradient">check</mat-icon>
                </button>
                <button mat-icon-button (click)="toggleReportDatePicker()">
                    <mat-icon class="text-xl">close</mat-icon>
                </button>
            </div>
            <div #chartWrapper class="chart-fullscreen-host" [class.is-fullscreen]="isChartFullscreen">
                <apx-chart *ngIf="chartOptions?.chart" [id]="chartData?.id || ''" [chart]="chartOptions.chart"
                    [toolbar]="chartOptions.chart?.['toolbar']" [colors]="chartOptions.colors"
                    [dataLabels]="chartOptions.dataLabels" [grid]="chartOptions.grid" [labels]="chartOptions.labels"
                    [legend]="chartOptions.legend" [plotOptions]="chartOptions.plotOptions"
                    [series]="chartOptions.series" [states]="chartOptions.states" [stroke]="chartOptions.stroke"
                    [fill]="chartOptions.fill"
                    [tooltip]="chartOptions.tooltip" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
                    [title]="from === 'report' || hideTitle ? '' : chartOptions.title"
                    [annotations]="chartOptions.annotations">
                </apx-chart>
            </div>

            <!-- Pinned Points Panel -->
            <div
                *ngIf="pinnedPointsArray.length > 0"
                class="pinned-points-panel"
            >
                <div class="pinned-points-header">
                    <span class="pinned-points-title">{{
                        t("Pinned Points")
                    }}</span>
                    <button
                        mat-icon-button
                        class="pinned-clear-btn"
                        (click)="clearPinnedPoints()"
                        [matTooltip]="t('Clear All')"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <div class="pinned-points-list">
                    <div
                        *ngFor="
                            let point of pinnedPointsArray;
                            trackBy: trackByIndex
                        "
                        class="pinned-point-item"
                        [class.pinned-point-highlighted]="
                            highlightedPointIndex === point.dataPointIndex
                        "
                        (click)="highlightPoint(point.dataPointIndex)"
                    >
                        <div class="pinned-point-header">
                            <span class="pinned-point-category">{{
                                point.category
                            }}</span>
                            <button
                                mat-icon-button
                                class="pinned-remove-btn"
                                (click)="
                                    removePinnedPoint(point.dataPointIndex)
                                "
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <div
                            *ngFor="let v of point.values"
                            class="pinned-point-value"
                        >
                            <span
                                class="pinned-color-dot"
                                [style.background]="v.color"
                            ></span>
                            <span class="pinned-series-name"
                                >{{ v.name }}:</span
                            >
                            <span class="pinned-series-val">{{ v.value }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
